var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"scrollTop",class:[{ 'scrollTop--visible': _vm.visible }, { 'scrollTop--mobile': _vm.$device.isMobile }],on:{"click":_vm.scrollTop}},[_c('span',{staticClass:"scrollTop__icon icon-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }